import {Component, Input, OnInit} from '@angular/core';
import {Point} from "@core/models/Point";
import {PointService} from "@pages/user/service/point/point.service";
import {CredentialsService} from "@core/authentication/credentials.service";
import {MatDialog} from "@angular/material/dialog";
import {Purchase, Reward} from "@app/feature/reward/models/Reward";
import {
  RewardRedeemConfirmationDialogComponent,
} from "@app/feature/reward/reward-redeem-confirmation-dialog/reward-redeem-confirmation-dialog.component";
import {RewardService} from "@app/feature/reward/service/reward.service";
import {
  RewardRedeemConfirmationData
} from "@app/feature/reward/reward-redeem-confirmation/reward-redeem-confirmation.component";


@Component({
  selector: 'app-reward-card',
  templateUrl: './reward-card.component.html',
  styleUrls: ['./reward-card.component.scss']
})
export class RewardCardComponent implements OnInit {
  constructor(
    private rewardService:RewardService,
    private pointService: PointService,
    private credentialsService:CredentialsService,
    public dialog: MatDialog,
  ) { }


  @Input()
  public reward:Reward

  @Input()
  public points:Point

  // This is the list of all purchases made by the user. Useful to guess email address to auto-fill
  @Input()
  public purchases:Purchase[]

  // This is a single purchase object
  @Input()
  public purchase:Purchase

  public participant_id:number

  ngOnInit(): void {
    this.participant_id = this.credentialsService.credentials.participant_id
    if(this.purchase) this.reward = this.purchase.reward
  }

  confirm_purchase(reward: Reward) {
    const dialogRef = this.dialog.open(RewardRedeemConfirmationDialogComponent, {
      panelClass: 'redeem-confirmation-dialog-container',
      autoFocus: false,
      closeOnNavigation: false,
      data: <RewardRedeemConfirmationData>{
        participant_id: this.participant_id,
        send_to: this.credentialsService.credentials.username,
        points: this.points,
        reward: reward,
        purchase: this.purchases
      }
    });

    dialogRef.afterClosed().subscribe((e: any) => {
      if (e) this.purchaseReward(e.reward.id, e.send_to)
    })
  }

  purchaseReward(reward_id: number, send_to: string) {
    this.rewardService.purchase(
      this.participant_id,
      reward_id,
      send_to
    ).subscribe()
  }


}
